/**
 * Normalise un payload exercice-tableau : V/F (`config.type === 'vraiFaux'`,
 * créé par `makeVraiFaux`) OU tableau générique (`colonnesLibres`… — qcm
 * véhicule sans choix). La table vraiFaux est cherchée en priorité, sinon la
 * première table quelle qu'elle soit. La consigne, elle, reste différenciée
 * par le renderer (CONSIGNES.vf vs CONSIGNES.table).
 *
 * Sortie :
 *   { num, question, lignes[], colonnes, correctIndices[] }
 *   où correctIndices[i] est l'index de la bonne colonne pour la ligne i
 *   (0 = Vrai, 1 = Faux dans le cas V/F).
 */
export const normalizeVraiFaux = (payload, num) => {
    const elements = payload?.elements_additionnels?.elements || [];
    const tableEl = elements.find(
        (e) => e?.type === 'table' && e.config?.type === 'vraiFaux'
    ) || elements.find((e) => e?.type === 'table');
    const cfg = tableEl?.config || {};
    const lignes = Array.isArray(cfg.lignes) ? cfg.lignes : [];
    const colonnes = Array.isArray(cfg.colonnes) && cfg.colonnes.length >= 2
        ? cfg.colonnes
        : ['Vrai', 'Faux'];
    const bonnesReponses = Array.isArray(cfg.bonnesReponses) ? cfg.bonnesReponses : [];
    return {
        num,
        question: payload?.texte || '',
        lignes,
        colonnes,
        correctIndices: bonnesReponses,
    };
};
